import { ELanguage } from 'types/languages';

export const getIsItalicAllowed = (language: ELanguage) =>
    ![ELanguage.Chinese, ELanguage.Japanese, ELanguage.Korean].includes(language);
